var _linearGradient, _path, _linearGradient2, _path2, _linearGradient3, _path3, _linearGradient4, _path4, _linearGradient5, _path5, _linearGradient6, _path6, _linearGradient7, _path7, _linearGradient8, _path8, _linearGradient9, _path9, _linearGradient10, _path10, _linearGradient11, _path11, _linearGradient12, _path12, _linearGradient13, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    id: "Dashboard",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 256,
    x2: 256,
    y1: 9.021,
    y2: 525.884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4285f4",
    className: "stopColor82d0d9 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fbbc05",
    className: "stopColorf2ac57 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ea4335",
    className: "stopColord94711 svgShape"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M432,368H80c-3.27,0-6.211,1.992-7.43,5.031l-16,40c-0.984,2.461-0.684,5.258,0.805,7.453 S61.344,424,64,424h384c2.656,0,5.137-1.32,6.625-3.516s1.789-4.992,0.805-7.453l-16-40C438.211,369.992,435.27,368,432,368z  M75.816,408l9.602-24h341.164l9.602,24H75.816z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 176,
    x2: 176,
    y1: 9.021,
    y2: 525.884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4285f4",
    className: "stopColor82d0d9 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fbbc05",
    className: "stopColorf2ac57 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ea4335",
    className: "stopColord94711 svgShape"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M176,272c35.129,0,60.227-19.234,63.938-49.008c0.285-2.281-0.422-4.57-1.941-6.289 S234.293,214,232,214h-62v-62c0-2.297-0.984-4.477-2.703-6c-1.723-1.516-4.016-2.188-6.285-1.938 C131.238,147.773,112,172.875,112,208C112,243.289,140.711,272,176,272z M154,162.094V222c0,4.422,3.582,8,8,8h59.91 c-7.012,18.984-27.453,26-45.91,26c-26.469,0-48-21.531-48-48C128,189.539,135.02,169.102,154,162.094z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 207.5,
    x2: 207.5,
    y1: 9.021,
    y2: 525.884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4285f4",
    className: "stopColor82d0d9 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fbbc05",
    className: "stopColorf2ac57 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ea4335",
    className: "stopColord94711 svgShape"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M183,209h49c2.293,0,4.477-0.984,5.996-2.703s2.227-4.008,1.941-6.289 c-3.598-28.828-27.125-52.352-55.949-55.945c-2.258-0.25-4.562,0.422-6.285,1.938c-1.719,1.523-2.703,3.703-2.703,6v49 C175,205.422,178.582,209,183,209z M191,161.977c14.516,4.82,26.199,16.5,31.023,31.023H191V161.977z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 256,
    x2: 256,
    y1: 9.021,
    y2: 525.884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4285f4",
    className: "stopColor82d0d9 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fbbc05",
    className: "stopColorf2ac57 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ea4335",
    className: "stopColord94711 svgShape"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M512,96c0-52.938-43.066-96-96-96c-47.472,0-86.901,34.669-94.555,80H88c-22.055,0-40,17.945-40,40 v222.547L0.508,469.188C0.172,470.086,0,471.039,0,472v16c0,13.234,10.766,24,24,24h464c13.234,0,24-10.766,24-24v-16 c0-0.961-0.172-1.914-0.508-2.812L464,342.547V179.011C492.645,162.381,512,131.442,512,96z M325.601,128 c13.221,37.226,48.698,64,90.399,64v104c0,4.414-3.59,8-8,8H104c-4.41,0-8-3.586-8-8V136c0-4.414,3.59-8,8-8H325.601z M64,120 c0-13.234,10.766-24,24-24h232c0,5.462,0.565,10.785,1.445,16H104c-13.234,0-24,10.766-24,24v160c0,13.234,10.766,24,24,24h304 c13.234,0,24-10.766,24-24V190.555c5.51-0.931,10.849-2.326,16-4.155V336H64V120z M496,488c0,4.414-3.59,8-8,8H24 c-4.41,0-8-3.586-8-8v-8h480V488z M170.246,464l4-16h163.508l4,16H170.246z M492.455,464H358.246l-6.484-25.938 C350.871,434.5,347.672,432,344,432H168c-3.672,0-6.871,2.5-7.762,6.062L153.754,464H19.545l42.002-112h388.906L492.455,464z  M416,176c-44.113,0-80-35.891-80-80s35.887-80,80-80s80,35.891,80,80S460.113,176,416,176z"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 412,
    x2: 412,
    y1: 9.021,
    y2: 525.884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4285f4",
    className: "stopColor82d0d9 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fbbc05",
    className: "stopColorf2ac57 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ea4335",
    className: "stopColord94711 svgShape"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M456,80V40c0-4.422-3.582-8-8-8s-8,3.578-8,8v40h-8V48c0-4.422-3.582-8-8-8s-8,3.578-8,8v32h-8V56 c0-4.422-3.582-8-8-8s-8,3.578-8,8v24h-8v-8c0-4.422-3.582-8-8-8s-8,3.578-8,8v8c-4.418,0-8,3.578-8,8s3.582,8,8,8h88 c4.418,0,8-3.578,8-8S460.418,80,456,80z"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 300,
    x2: 300,
    y1: 9.021,
    y2: 525.884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4285f4",
    className: "stopColor82d0d9 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fbbc05",
    className: "stopColorf2ac57 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ea4335",
    className: "stopColord94711 svgShape"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M256,264h11.719l13.625,20.438c1.488,2.234,3.992,3.562,6.656,3.562c0.164,0,0.332-0.008,0.496-0.016 c2.848-0.18,5.383-1.859,6.66-4.406l16.031-32.062l9.383,23.453c1.219,3.039,4.16,5.031,7.43,5.031h16c4.418,0,8-3.578,8-8 s-3.582-8-8-8h-10.582l-13.988-34.969c-1.172-2.93-3.949-4.891-7.098-5.023c-3.141-0.281-6.082,1.594-7.488,4.414l-17.836,35.672 l-8.352-12.531c-1.484-2.227-3.98-3.562-6.656-3.562h-16c-4.418,0-8,3.578-8,8S251.582,264,256,264z"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 380,
    x2: 380,
    y1: 9.021,
    y2: 525.884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4285f4",
    className: "stopColor82d0d9 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fbbc05",
    className: "stopColorf2ac57 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ea4335",
    className: "stopColord94711 svgShape"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M368,280h24c4.418,0,8-3.578,8-8s-3.582-8-8-8h-24c-4.418,0-8,3.578-8,8S363.582,280,368,280z"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 272,
    x2: 272,
    y1: 9.021,
    y2: 525.884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4285f4",
    className: "stopColor82d0d9 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fbbc05",
    className: "stopColorf2ac57 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ea4335",
    className: "stopColord94711 svgShape"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M264,184h16c4.418,0,8-3.578,8-8s-3.582-8-8-8h-16c-4.418,0-8,3.578-8,8S259.582,184,264,184z"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 324,
    x2: 324,
    y1: 9.021,
    y2: 525.884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4285f4",
    className: "stopColor82d0d9 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fbbc05",
    className: "stopColorf2ac57 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ea4335",
    className: "stopColord94711 svgShape"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M304,184h40c4.418,0,8-3.578,8-8s-3.582-8-8-8h-40c-4.418,0-8,3.578-8,8S299.582,184,304,184z"
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 304,
    x2: 304,
    y1: 9.021,
    y2: 525.884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4285f4",
    className: "stopColor82d0d9 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fbbc05",
    className: "stopColorf2ac57 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ea4335",
    className: "stopColord94711 svgShape"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M264,216h80c4.418,0,8-3.578,8-8s-3.582-8-8-8h-80c-4.418,0-8,3.578-8,8S259.582,216,264,216z"
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 384,
    x2: 384,
    y1: 9.021,
    y2: 525.884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4285f4",
    className: "stopColor82d0d9 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fbbc05",
    className: "stopColorf2ac57 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ea4335",
    className: "stopColord94711 svgShape"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M376,128h16c4.418,0,8-3.578,8-8s-3.582-8-8-8h-16c-4.418,0-8,3.578-8,8S371.582,128,376,128z"
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 436,
    x2: 436,
    y1: 9.021,
    y2: 525.884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4285f4",
    className: "stopColor82d0d9 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fbbc05",
    className: "stopColorf2ac57 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ea4335",
    className: "stopColord94711 svgShape"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M456,112h-40c-4.418,0-8,3.578-8,8s3.582,8,8,8h40c4.418,0,8-3.578,8-8S460.418,112,456,112z"
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 416,
    x2: 416,
    y1: 9.021,
    y2: 525.884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4285f4",
    className: "stopColor82d0d9 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fbbc05",
    className: "stopColorf2ac57 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ea4335",
    className: "stopColord94711 svgShape"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M456,136h-80c-4.418,0-8,3.578-8,8s3.582,8,8,8h80c4.418,0,8-3.578,8-8S460.418,136,456,136z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.c5090ff491d672284f41325c733cc379.svg";
export { ForwardRef as ReactComponent };